import type { Ref } from 'react'

import { cn } from '@/lib/utils'
import { Button } from '@/ui/button'

export function RetryNotice({
  message,
  onRetry,
  disabled = false,
  buttonRef,
  buttonLabel = 'Retry',
  className,
}: {
  message: string
  onRetry: () => void
  disabled?: boolean
  buttonRef?: Ref<HTMLButtonElement>
  buttonLabel?: string
  className?: string
}) {
  return (
    <div className={cn('flex flex-col items-start gap-3', className)}>
      <p role="alert" className="text-destructive text-sm">
        {message}
      </p>
      <Button
        ref={buttonRef}
        type="button"
        variant="outline"
        size="sm"
        disabled={disabled}
        focusableWhenDisabled
        onClick={onRetry}
      >
        {buttonLabel}
      </Button>
    </div>
  )
}
